let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("ffQaD"), load("kvRbA"), load("47Kh6")]).then(() => parcelRequire('1Rjyb'));